
interface SelectionHookProps {
  selectedRegion: any;
  setShowChiapasCities: (v: boolean) => void;
  setShowHidalgoCities: (v: boolean) => void;
  toastShownRef: React.MutableRefObject<{ chiapas: boolean; hidalgo: boolean }>;
  onRegionClick: (region: any) => void;
  onCityClick?: (city: any) => void;
  chiapas_cities: any[];
  hidalgo_cities: any[];
}

export function useMexicoMapSelection({
  selectedRegion,
  setShowChiapasCities,
  setShowHidalgoCities,
  toastShownRef,
  onRegionClick,
  onCityClick,
  chiapas_cities,
  hidalgo_cities
}: SelectionHookProps) {
  const handleInternalRegionClick = (region: any) => {
    console.log('Internal region click:', region.english_name);
    onRegionClick(region);
    if (region.region_id === 'CHIS') {
      setShowChiapasCities(true);
      setShowHidalgoCities(false);
      toastShownRef.current.chiapas = true;
    } else if (region.region_id === 'HGO') {
      setShowHidalgoCities(true);
      setShowChiapasCities(false);
      toastShownRef.current.hidalgo = true;
    } else {
      setShowChiapasCities(false);
      setShowHidalgoCities(false);
    }
  };

  const handleInternalCityClick = (city: any) => {
    console.log('Internal city click:', city.name);
    if (onCityClick) {
      onCityClick(city);
    }
  };

  const getCitiesToShow = () => {
    if (selectedRegion?.region_id === "CHIS") {
      return chiapas_cities;
    } else if (selectedRegion?.region_id === "HGO") {
      return hidalgo_cities;
    }
    return [];
  };

  return {
    handleInternalRegionClick,
    handleInternalCityClick,
    getCitiesToShow
  };
}
